/** Pan/zoom state for the learner floor map, in floor units. */
export interface View {
  k: number;
  x: number;
  y: number;
}

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 4;

/** Keep the zoom in range and the floor inside the frame. */
export function clampView(view: View, width: number, height: number): View {
  const k = Math.min(Math.max(view.k, MIN_ZOOM), MAX_ZOOM);
  return {
    k,
    x: Math.min(0, Math.max(width * (1 - k), view.x)),
    y: Math.min(0, Math.max(height * (1 - k), view.y)),
  };
}

/** Zoom to `k` keeping the floor point under (`px`, `py`) fixed. */
export function zoomAt(view: View, k: number, px: number, py: number): View {
  const ratio = k / view.k;
  return { k, x: px - (px - view.x) * ratio, y: py - (py - view.y) * ratio };
}
